import { defineMessages } from "react-intl";

const SharedComponentMessages = defineMessages({
  New: {
    id: "shared.button.label.addnew",
    defaultMessage: "New",
  },
  Filters: {
    id: "shared.button.label.filters",
    defaultMessage: "Filters",
  },
  Save: {
    id: "shared.button.label.save",
    defaultMessage: "Save",
  },
  Cancel: {
    id: "shared.button.label.cancel",
    defaultMessage: "Cancel",
  },
  Custom: {
    id: "shared.date.range.dropdown.custom",
    defaultMessage: "Custom",
  },
  GroupNamePlaceholder: {
    id: "shared.groupName.placeholder",
    defaultMessage: "Group Name",
  },
  matchExactly: {
    id: "shared.search.bar.matchExactly",
    defaultMessage: "Match Exactly",
  },
  contains: {
    id: "shared.search.bar.contains",
    defaultMessage: "Contains",
  },
  include: {
    id: "shared.table.column.include",
    defaultMessage: "Include",
  },
  exclude: {
    id: "shared.table.column.exclude",
    defaultMessage: "Exclude",
  },
  tooltipIncluded: {
    id: "shared.table.row.tooltipIncluded",
    defaultMessage: "Add to Included",
  },
  removeIncludeTooltip: {
    id: "shared.table.row.removeIncludeTooltip",
    defaultMessage: "Remove from Included",
  },
  tooltipExcluded: {
    id: "shared.table.row.tooltipExcluded",
    defaultMessage: "Add to Excluded",
  },
  removeExcludeTooltip: {
    id: "shared.table.row.removeExcludeTooltip",
    defaultMessage: "Remove from Excluded",
  },
  ResetFilters: {
    id: "shared.button.label.resetfilters",
    defaultMessage: `Reset ({activeFiltersCount})`,
  },
  Percent: {
    id: "shared.percent",
    defaultMessage: "{value}%",
  },
  maxBidCPMComponent: {
    id: "max.bid.cpm",
    defaultMessage: "{msgs} {value}",
    parameterized: true,
  },
  maxBidCPMToolTip: {
    id: "max.bid.cpm.tooltip",
    defaultMessage:
      "The maximum possible CPM cost for this selection of contextual segments",
  },
  maxBidCPMAudienceToolTip: {
    id: "max.bid.cpm.audience.tooltip",
    defaultMessage:
      "The maximum possible CPM cost for this selection of audience segments",
  },
  minMaxBidCPMToolTip: {
    id: "min.max.bid.cpm.tooltip",
    defaultMessage:
      "Estimated range based on selected segments. Actual cost will depend on matched segments and vendor pricing logic.",
  },
  of: {
    defaultMessage: "of",
    id: "shared.table.paginator.of",
  },
  emptyMessage: {
    defaultMessage: "No results found.",
    id: "shared.table.list.emptyMessage",
  },
});

export default SharedComponentMessages;
